import { cn } from '@/lib/utils'
import * as LabelPrimitive from '@radix-ui/react-label'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

const labelVariants = cva(
  'leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
  {
    variants: {
      variant: {
        'dialog-title': 'text-2xl font-light',
        'dialog-field': 'text-sm font-light font-circular-xx',
        'schedule-title': 'text-base font-light',
        'schedule-field': 'text-sm font-normal',
        'registration-field': 'text-xs font-light',
        'registration-title': 'text-2xl font-light',
        checkbox: 'text-xl font-light font-circular-xx',
      },
      error: { true: 'text-error-300' },
    },
  },
)

export type LabelProps = React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
  VariantProps<typeof labelVariants> & { htmlFor: string }

export const Label = React.forwardRef<React.ElementRef<typeof LabelPrimitive.Root>, LabelProps>(
  ({ className, error, variant, ...props }, ref) => (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(labelVariants({ variant, error }), className)}
      {...props}
    />
  ),
)
Label.displayName = LabelPrimitive.Root.displayName

export const LabelAsterisk = ({ size = 'sm' }: Readonly<{ size?: 'sm' | 'md' }>) => (
  <span className={cn('ml-0.5', { 'text-xs': size === 'sm', 'text-base': size === 'md' })}>*</span>
)

export const CharacterCount = ({ length = 0, max }: Readonly<{ length?: number; max: number }>) => (
  <span className='font-circular-xx text-xs font-light'>{`${length}/${max}`}</span>
)
